import React, { useEffect } from 'react';
import Layout from '../Components/Layout/Layout';
import '../styles/globals.css';
import { useRouter } from 'next/router';

function MyApp({ Component, pageProps }) {
  const router = useRouter();

  useEffect(() => {
    const path = router.pathname;
    const isArabic = path.split('/')[1] != 'en';

    if(isArabic) {
      document.body.classList.add("arabicFF");
    } else {
      document.body.classList.remove("arabicFF");
    }
  }, []);

  return (
    <Layout>
      <Component {...pageProps} />
    </Layout>
  )
}

export default MyApp
